export default __webpack_public_path__ + "static/media/mobile.bf4c7a4d.svg";